import { render } from "./PlusTransparentIcon.vue?vue&type=template&id=778bd522"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/PlusTransparentIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "778bd522"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('778bd522', __exports__)) {
    api.reload('778bd522', __exports__)
  }
  
  module.hot.accept("./PlusTransparentIcon.vue?vue&type=template&id=778bd522", () => {
    api.rerender('778bd522', render)
  })

}


export default __exports__